import { LYSTypography } from '@core/components/Primitives'
import ProductShortInformation from '@core/components/shared/ProductShortInformation'
import getSku from '@core/utils/models/getSku'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import { RenderProp, template, Slot } from '@core/utils/templates'
import style from './index.module.less'

interface ProductInformationSlots {
  title?: RenderProp<void>
  description?: RenderProp<void>
  shortInformation?: RenderProp<void>
}

const ProductInformation = template<any, ProductInformationSlots>(
  ({ slots }) => {
    const { product, variant } = useProductDetailContext() || {}

    if (!product || !variant) return null

    return (
      <div className={style.productInfo}>
        <Slot render={slots?.title}>
          <LYSTypography.Title
            visualAppearance={'h3'}
            level={1}
            data-testid="pdp-product-info-product-name"
          >
            {product.name}
          </LYSTypography.Title>
        </Slot>
        <Slot render={slots?.description}>
          <LYSTypography.Paragraph>
            {product.shortDescription}
          </LYSTypography.Paragraph>
        </Slot>
        <Slot render={slots?.shortInformation}>
          <div className={style.variantInfo}>
            <ProductShortInformation
              variationName={product.variationName}
              sku={getSku(product, variant)}
              skuProvidedBySupplier={product.skuProvidedBySupplier}
              gtin={variant.gtin}
            />
          </div>
        </Slot>
      </div>
    )
  }
)

export default ProductInformation
